import { graphql } from 'react-relay';
import commitMutation from 'relay-commit-mutation-promise';

const mutation = graphql`
    mutation requestPasswordEmailMutation($input: RequestPasswordEmailInput!) {
        requestPasswordEmail(input: $input) {
            message
        }
    }
`;

export function requestPasswordEmailMutation(environment, email, urlRedirect) {
    return commitMutation(environment, {
        mutation,
        variables: {
            input: { email, urlRedirect },
        },
    });
}
